import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LoginPage, ProfilePage } from './pages';
import {
  AdminLogin,
  AdminLayout,
  AdminDashboard,
  AdminUsers,
  AdminSessions,
  AdminAppointments,
  AdminNotifications,
  AdminSettings,
  AdminTrainingTypes,
} from './components/Admin';

function App() {
  return (
    <Router>
      <Routes>
        {/* User Routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/profile" element={<ProfilePage />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/*" element={<AdminLayout />}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="sessions" element={<AdminSessions />} />
          <Route path="appointments" element={<AdminAppointments />} />
          <Route path="notifications" element={<AdminNotifications />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="training-types" element={<AdminTrainingTypes />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
